import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeId = 'dark' | 'light' | 'midnight' | 'netcore' | 'forest';

const THEME_STORAGE_KEY = 'echo-theme';

interface ThemeState {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
}

const applyThemeToDocument = (theme: ThemeId) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme);
  }
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'netcore',
      setTheme: (theme) => {
        applyThemeToDocument(theme);
        set({ theme });
      },
    }),
    {
      name: THEME_STORAGE_KEY,
      onRehydrateStorage: () => (state) => {
        if (state) {
          if ((state.theme as string) === 'dawn') {
            state.theme = 'netcore';
          }
          applyThemeToDocument(state.theme);
        }
      },
    }
  )
);
